import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { restoreWebTheme } from './theme/applyTheme';
import App from './App';

// Paint the saved theme before React mounts, so there is no flash.
restoreWebTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
